import { axios } from '../config/axios';

const endPoint = '/project/project-master';

const getAll = () => {
    return axios.get(`${endPoint}`);
}

const getListByPage = async (search, pageNumber, limit) => {
    return axios.post(`${endPoint}/pagination`, {
        search: search,
        page: pageNumber,
        limit: limit
    });
}

const getById = async (masterId) => {
    return axios.get(`${endPoint}/${masterId}`);
}

const createMaster = (formData) => {
    return axios.post(`${endPoint}`, formData);
}

const updateMaster = (masterId, formData) => {
    return axios.put(`${endPoint}/${masterId}`, formData);
}

const uploadCandidate = (masterId, formData) => {
    return axios.put(`${endPoint}/upload-candidate/${masterId}`, formData);
}

const deleteMaster = (masterId) => {
    return axios.delete(`${endPoint}/${masterId}`);
}

const deleteAllCandidates = (masterId) => {
    return axios.delete(`${endPoint}/delete-all-candidates/${masterId}`);
}

const getCandidateDataCsv = (masterId) => {
    return axios.get(`${endPoint}/download-csv/${masterId}`, {
        responseType: 'blob',
    });
}

// Import Candidates: the backend asks the Forms service for the exam's candidate file; the import starts once it is uploaded.
const requestCandidatesFile = (masterId) => {
    return axios.post(`${endPoint}/forms-gen-request-candidates`, { projectMasterId: masterId });
}

const getExamHalls = ({ driveId, courseId, batchId, examDate }) => {
    return axios.post(`${endPoint}/get-exam-halls`, {
        driveId,
        courseId,
        batchId,
        examDate
    });
}

const getExamHallAndServerId = ({ driveId, courseId, batchId, examDate }) => {
    return axios.post(`${endPoint}/get-exam-hall-and-server-id`, {
        driveId,
        courseId,
        batchId,
        examDate
    });
}

const getServerIds = ({ driveId, courseId, batchId, examDate, examHallId }) => {
    return axios.post(`${endPoint}/get-server-ids`, {
        driveId,
        courseId,
        batchId,
        examDate,
        examHallId
    });
}


const getExamDates = ({ driveId, courseId, batchId }) => {
    return axios.post(`${endPoint}/get-exam-dates`, {
        driveId,
        courseId,
        batchId
    });
}

const listForContentDashboard = (pageNumber, limit) => {
    return axios.post(`${endPoint}/list-for-content-dashboard-with-pagination`, {
        page: pageNumber,
        limit: limit
    });
}

const listByDriveAndCourse = (driveId, courseId) => {
    return axios.post(`${endPoint}/list-by-drive-and-course`, { driveId, courseId });
}

const enableExam = (masterId, body) => {
    return axios.post(`${endPoint}/enable-exam/${masterId}`, body);
}

const listWithConfigurationStatusByPagination = (search, pageNumber, limit) => {
    return axios.post(`${endPoint}/pagination/list-with-configuration-status`, {
        search: search,
        page: pageNumber,
        limit: limit
    });
}

const getDataForEnableExam = (configurationId) => {
    return axios.get(`${endPoint}/data-for-enable-exam/${configurationId}`);
}

const getDataForScoreManagement = () => {
    return axios.get(`${endPoint}/data-for-score-management`);
}

const getDataForCandidateShortlist = () => {
    return axios.get(`${endPoint}/data-for-candidate-shortlist`);
}

const getExamSummary = (projectMasterId) => {
    return axios.get(`${endPoint}/exam-summary/${projectMasterId}`);
}

const downloadFeedbackReport = (projectMasterId) => {
    return axios.get(`${endPoint}/download-feedback-report/${projectMasterId}`, {
        responseType: 'blob',
    });
}

const changeSetPassword = (masterId, body) => {
    return axios.post(`${endPoint}/change-set-password/${masterId}`, body);
}

const changeBulkTechnicalIssueOccurredStatus = (masterId, body) => {
    return axios.post(`${endPoint}/change-technical-issue-occurred-status/${masterId}`, body);
}


export {
    getAll,
    getListByPage,
    getById,
    createMaster,
    updateMaster,
    uploadCandidate,
    deleteMaster,
    deleteAllCandidates,
    getCandidateDataCsv,
    requestCandidatesFile,
    getExamHalls,
    getExamHallAndServerId,
    getServerIds,
    getExamDates,
    listForContentDashboard,
    listByDriveAndCourse,
    enableExam,
    listWithConfigurationStatusByPagination,
    getDataForEnableExam,
    getDataForScoreManagement,
    getDataForCandidateShortlist,
    getExamSummary,
    downloadFeedbackReport,
    changeSetPassword,
    changeBulkTechnicalIssueOccurredStatus,
}